import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "validation", "component"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import Text from '../components/form/fields/Text';
import { safeCall } from './React';
export var getDefaultValue = function getDefaultValue(component) {
  var val = Text == null ? void 0 : Text.defaultValue;
  if (val !== undefined) {
    return val;
  }
  return '';
};
export var getFieldByName = function getFieldByName(fields, name) {
  return fields.find(function (field) {
    return field.name === name;
  });
};
export var defineField = function defineField(_ref) {
  var name = _ref.name,
    validation = _ref.validation,
    component = _ref.component,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread(_objectSpread({}, otherProps), {}, {
    name: name,
    validation: validation || false,
    component: component || Text,
    defaultValue: getDefaultValue(component)
  });
};
export var defineFieldArray = function defineFieldArray(name, subfields) {
  return subfields.map(function (subfield) {
    return _objectSpread(_objectSpread({}, subfield), {}, {
      name: "".concat(name, ".*.").concat(subfield.name)
    });
  });
};
export var compileRules = function compileRules(fields) {
  return fields.filter(function (_ref2) {
    var validation = _ref2.validation;
    return !!validation;
  }).reduce(function (r, _ref3) {
    var name = _ref3.name,
      validation = _ref3.validation;
    return _objectSpread(_objectSpread({}, r), {}, _defineProperty({}, name, validation));
  }, {});
};
export var compileInitialValues = function compileInitialValues(fields) {
  var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread(_objectSpread({}, fields.reduce(function (r, _ref4) {
    var name = _ref4.name,
      defaultValue = _ref4.defaultValue;
    return _objectSpread(_objectSpread({}, r), {}, _defineProperty({}, name, defaultValue));
  }, {})), values);
};
export var getFieldTranslations = function getFieldTranslations(t, name) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ['label', 'placeholder', 'help'];
  return props.reduce(function (r, prop) {
    return _objectSpread(_objectSpread({}, r), {}, _defineProperty({}, prop, t("".concat(name, "_").concat(prop))));
  }, {
    id: name
  });
};
export var renderComponent = function renderComponent(properties, component) {
  var Component = component || Text;
  return /*#__PURE__*/React.createElement(Component, properties);
};
export var generateFieldsProps = function generateFieldsProps(fields, callback) {
  return fields.reduce(function (r, field) {
    return _objectSpread(_objectSpread({}, r), {}, _defineProperty({}, field.name, safeCall(callback, field)));
  }, {});
};